export default [{
  state: 'login',
  config: {
    url: '/login?sha1&loggedOut',
    component: 'login',
  },
}];



// WEBPACK FOOTER //
// ./src/app/login/login.routes.js